import { useMediaQuery } from '@mantine/hooks';
import { isNative } from '@/shared/lib/nativePlatform';

/**
 * Vero quando l'app deve mostrare la shell mobile dedicata:
 * - sempre dentro l'app (iOS/Android), oppure
 * - su viewport ≤ 48em (768px) nel browser.
 *
 * Il desktop largo continua a usare la shell classica con sidebar.
 */
export function useIsMobileShell(): boolean {
  // getInitialValueInEffect:false → valuta matchMedia già al primo render (client),
  // così non c'è un frame "desktop" iniziale che farebbe rimbalzare le route
  // mobile-only (es. /planning/new) prima che la media query si risolva.
  const narrow = useMediaQuery('(max-width: 48em)', false, { getInitialValueInEffect: false }) ?? false;
  return isNativePlatform() || narrow;
}

/**
 * True se giriamo dentro l'app.
 *
 * ⚠️ Interrogava il guscio precedente, e nell'APK rispondeva **false**.
 * Il difetto non si vedeva su un telefono perche' la seconda condizione (`viewport <= 768px`)
 * era vera comunque: la shell mobile compariva per la larghezza, non perche' fossimo nell'app.
 * Si vedeva su un **tablet**, dove l'APK mostrava la shell da scrivania con la colonna laterale.
 *
 * Ora passa da `isNative()`, che e' l'unico punto che sa rispondere a questa domanda.
 */
export function isNativePlatform(): boolean {
  return isNative();
}
